<template>
  <div>
    <router-link to="/social"
      class="relative inline-flex items-center my-2 py-2 text-purple text-sm leading-5 font-medium font-bebas text-3xl
         transition ease-in-out duration-150 border-b-2 border-purple">
      Back to Topics
    </router-link>
    <div v-if="loading">
      <submission-spinner></submission-spinner>
    </div>
    <div
      class="bg-vlight-paper shadow overflow-hidden sm:rounded-lg mt-2"
      v-if="topic && !loading"
    >
      <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
        <div class="flex flex row">
          <avatar :user-display="topic.userDisplay"></avatar>
          <div class="ml-2">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              {{ topic.topic }}
            </h3>
            <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-500">
              Started by {{ topic.userDisplay }} on {{ postDate }}
            </p>
          </div>
        </div>
      </div>
      <vue-markdown :source="topic.body" class="px-4 py-5 sm:px-6"></vue-markdown>
    </div>
    
    <DynamicScroller
      :items="messages"
      :min-item-size="120"
      class="bg-vlight-paper shadow overflow-y-auto sm:rounded-md mt-6"
      style="max-height: 500px"
      ref="messageChat"
      v-on:visible="handleScrollerVisible"
    >
      <template v-slot="{ item, index, active }">
        <DynamicScrollerItem
          :item="item"
          :active="active"
          :size-dependencies="[item.body]"
          :data-index="index"
          v-bind:class="{ 'border-t border-gray-200': index > 0 }"
        >
        <topic-message
          :message="item"
          v-on:remove-message="handleRemoveMessage"
        ></topic-message>
        </DynamicScrollerItem>
      </template>
    </DynamicScroller>
    <div class="mt-4">
      <topic-response-box :id="id" v-if="loggedIn"></topic-response-box>
      <if-can-take-part></if-can-take-part>
    </div>
  </div>
</template>

<script>
import { DynamicScroller } from "vue-virtual-scroller";
import { DynamicScrollerItem } from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import { topicsCollection } from "../utils/firebase";
import TopicMessage from "../components/TopicMessage";
import TopicResponseBox from "../components/TopicResponseBox";
import Avatar from "../components/Avatar";
import SubmissionSpinner from "../components/SubmissionSpinner";
import { mapGetters } from "vuex";
import { removeTopicComment } from "../utils/functions";
import IfCanTakePart from "../components/IfCanTakePart";
import VueMarkdown from "vue-markdown";

export default {
  name: "Topic",
  components: {
    IfCanTakePart,
    SubmissionSpinner,
    Avatar,
    TopicResponseBox,
    TopicMessage,
    DynamicScroller,
    DynamicScrollerItem,
    VueMarkdown
  },
  data() {
    return {
      loading: true,
      id: null,
      topic: null,
      messagesRef: null,
      messages: [],
      messagesUnsubscribe: null
    };
  },
  computed: {
    ...mapGetters(["loggedIn"]),
    postDate() {
      if (this.topic) {
        return this.topic.timestamp.toDate().toLocaleString();
      } else {
        return "";
      }
    }
  },
  created() {
    this.id = this.$route.params.id;
    this.messagesRef = topicsCollection.doc(this.id).collection("messages");

    //Get the data
    topicsCollection
      .doc(this.id)
      .get()
      .then(doc => (this.topic = doc.data()));

    // Get messages
    this.loading = true;
    this.messages = [];
    this.messagesUnsubscribe = this.messagesRef
      .orderBy("timestamp", "asc")
      .onSnapshot(querySnapshot => {
        this.loading = false;
        querySnapshot.docChanges().forEach(change => {
          const doc = change.doc;
          if (change.type === "added") {
            this.messages.push({ id: doc.id, ...doc.data() });
          }

          if (change.type === "modified") {
            const index = this.messages.findIndex(
              item => item.id === change.doc.id
            );
            this.messages.splice(index, 1, { id: doc.id, ...doc.data() });
          }

          if (change.type === "removed") {
            const index = this.messages.findIndex(
              item => item.id === change.doc.id
            );
            this.messages.splice(index, 1);
          }
        });
        this.$nextTick(() => (this.scrollToBottom()));
      });
  },
  beforeDestroy() {
    if (this.messagesUnsubscribe) {
      this.messagesUnsubscribe();
    }
  },
  methods: {
    //
    // Remove a message if you are admin
    //
    handleRemoveMessage(messageID) {
      this.$store.dispatch("setDeletedMessageId", messageID);
      removeTopicComment(this.id, messageID);
    },
    handleScrollerVisible() {
      this.scrollToBottom();
    },
    scrollToBottom() {
      console.info("From scrollToBottom function");
      this.$refs.messageChat.scrollToBottom();
    }
  }
};
</script>

<style scoped>
.emoji-mart {
  position: absolute;
  top: -400px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
</style>
